import { ContentfulOrderProduct } from '@ravago/shared/page-data/models/contentful';
import { Color, PackagingGroup, ProductDetail } from '@ravago/shared/page-data/models/elements';

export abstract class ProductUtils {
  static async getProductByEntryId(locale: string, entryId?: string): Promise<ContentfulOrderProduct | undefined> {
    const response = await fetch(`/api/products/productByEntryId?locale=${locale}&entryId=${entryId}`);
    if (response.ok) {
      return response.json();
    }
    return undefined;
  }

  static async getProductDetails(productId: string): Promise<ProductDetail | undefined> {
    const url = `/api/products/${productId}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      cache: 'no-cache'
    });

    if (!response.ok) return undefined;
    return response.json();
  }

  static async getCustomerProductColors(productId: string): Promise<Color[] | undefined> {
    const url = `/api/customer/products/${productId}/colors`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      cache: 'no-cache'
    });
    if (!response.ok) return undefined;
    return response.json();
  }

  static async getCustomerProductPackagingGroups(productId: string): Promise<PackagingGroup[] | undefined> {
    const url = `/api/customer/products/${productId}/packaging-groups`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      cache: 'no-cache'
    });
    if (!response.ok) return undefined;
    return response.json();
  }
}
